import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Usuario } from 'src/app/models/usuario';
import { Empresa } from './../../../models/empresa';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';  // eta linea es para tranferir datos y cerrar dialog
import { EmpresaService } from 'src/app/services/empresa.service';
import { EmailService } from 'src/app/services/email/email.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-captura',
  templateUrl: './captura.component.html',
  styleUrls: ['./captura.component.css']
})




export class CapturaComponent implements OnInit {
  form: FormGroup;
  usuariosmx: Usuario[] =[];
  usermx: Usuario[];
   


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CapturaComponent>,
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    public empresaService: EmpresaService,
    public emailService: EmailService,
    private spinner: NgxSpinnerService,
    
  ) {

  }

  ngOnInit() {
    this.usermx = this.data.infousuariosmx;
    //console.log(this.usuariosmx);
     this.muestrausuariosmx();
     this.buildForm();
    
  //  console.log ('enviado a dialog', this.data);
  }

  nuevoRegistro() {
    this.form.reset();

  }

  private buildForm() {
    this.form =  this.formBuilder.group({
      nombreEmpresa: [this.data.identificador.idempresa.nombrempresa, [Validators.required]],
      nombrecliente:[this.data.identificador.nombrecliente, [Validators.required]],
      alias: [this.data.identificador.alias, [Validators.required]],
      apellido: [this.data.identificador.apellido, [Validators.required]],
      email: [this.data.identificador.idempresa.email, [Validators.required, Validators.email]],
      emailpersonal: [this.data.identificador.emailpersonal, [Validators.required, Validators.email]],
      telefono: [this.data.identificador.idempresa.telefono, [Validators.required]],
      celular: [this.data.identificador.idempresa.celular, [Validators.required]],
      direccionweb: [this.data.identificador.idempresa.direccionweb, [Validators.required]],
      direccion: [this.data.identificador.idempresa.direccion, [Validators.required]],
      ciudad: [this.data.identificador.idempresa.ciudad, [Validators.required]],
      pais: [this.data.identificador.idempresa.pais, [Validators.required]],
     
      zipcode: [this.data.identificador.idempresa.zipcode, [Validators.required]],
      estado: [this.data.identificador.idempresa.estado, [Validators.required]],
      role: [this.data.identificador.role, [Validators.required]],
      activado: [this.data.identificador.activado, [Validators.required]],
      _idusuario: [this.data.identificador._id],
      // este campo que e sla claave del registro se usara para saber si es edicion o agrega nuevo
      _idempresa: [this.data.identificador.idempresa._id],
      usuariosmx: [this.data.identificador.idempresa.usermx],
      xlsvalidado: [this.data.identificador.idempresa.validaformato],

      chkdia: [this.data.identificador.idempresa.firmatemporaldia],
      ckhsemana: [this.data.identificador.idempresa.firmatemporalsem],
      chkmes: [this.data.identificador.idempresa.firmatemporalmes],
      chkano: [this.data.identificador.idempresa.firmatemporalano],
      chkexcursion: [this.data.identificador.idempresa.firmatemporalexc],
      
      

    });

  //   this.form.valueChanges
  //   .pipe(debounceTime(500)
  //   )
  //   .subscribe(value => {
  //   console.log (value);
  // });

  }



  save(event: Event) {


 event.preventDefault();
 if (this.form.valid) {

    const value = this.form.value;


   console.log (this.usermx);

    const empresa = new Empresa(
      this.form.value.nombreEmpresa,
      this.form.value.nombrecliente,
      this.form.value.apellido,
      this.form.value.email,
      this.form.value.telefono,
      this.form.value.celular,
      this.form.value.direccionweb,
      this.form.value.direccion,
      this.form.value.ciudad,
      this.form.value.estado,
      this.form.value.pais,
      this.form.value.zipcode,
      null,
      this.form.value.emailpersonal,
      null,
      this.form.value.alias,
      this.form.value.role,
      null,
      this.form.value.activado,
      this.form.value._idusuario,
      this.form.value.usuariosmx,
      this.form.value.xlsvalidado,
      this.form.value.chkdia,
      this.form.value.chksemana,
      this.form.value.chkmes,
      this.form.value.chkano,
      this.form.value.chkexcursion

      

    );

    console.log ("datos q se recibe", empresa);







    if  (this.form.value.__idusuarioid === null) {
     // alert ('agregar');
     // console.log ('lo que se agregara', empresa);
    //   this.usuarioService.crearUsuarioformulario( empresa )
    //  .subscribe ( resp => {


    //  });

    } else {
    // si encuentra en el text _id  informacion quiee decir que es edicion

      //  alert ('edicion');
        this.empresaService.modificaempresausuario( empresa, this.data.identificador.idempresa._id )
      .subscribe ( resp => {

        this.enviaemailtocliente();

     });







    }





 } else {
   alert ('invalido');
   this.form.markAllAsTouched();
 }

  }





  closeDialog() {
  this.dialogRef.close();

  }


 muestrausuariosmx(){
   this.usuarioService.listadototalusuariosmx()
    .subscribe( resp =>{
        this.usuariosmx =  resp.usuario
     
    });
 }


  // guardarusuarios(listadousuario: Usuario) {
  //  this.usuarioService.actualizaUsuarios(listadousuario)
 //   .subscribe();
 // }


  enviaemailtocliente() {

    const subJet = 'this.subjettxt';
    this.spinner.show();
    const direccionemail = this.form.value.emailpersonal;

    this.emailService.sendEmailtocliente(direccionemail,  subJet)
           .subscribe(
             licen => {
              this.spinner.hide();

              },

             );
      }


  }


